import React from 'react';
import { BarChart2, Activity } from 'lucide-react';

const ScenarioAnalysisSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  if (!formData.scenarioAnalysis) {
    return (
      <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
        <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <BarChart2 className="w-5 h-5 mr-2 text-orange-500" />
          Анализ сценариев
        </h3>
        
        <div className="mb-2">
          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="scenarioAnalysis"
                name="scenarioAnalysis"
                type="checkbox"
                checked={formData.scenarioAnalysis}
                onChange={handleInputChange}
                className="form-checkbox"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="scenarioAnalysis" className="font-medium text-gray-700 dark:text-gray-300">
                Провести сценарный анализ
              </label>
              <p className="text-gray-500 dark:text-gray-400">
                Расчет инвестиции в пессимистичном, базовом и оптимистичном сценариях
              </p>
            </div>
          </div>
          {errors.scenarioAnalysis && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.scenarioAnalysis}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-4 rounded-lg border border-orange-200 dark:border-orange-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <BarChart2 className="w-5 h-5 mr-2 text-orange-500" />
        Анализ сценариев
      </h3>
      
      <div className="mb-2">
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              id="scenarioAnalysis"
              name="scenarioAnalysis"
              type="checkbox"
              checked={formData.scenarioAnalysis}
              onChange={handleInputChange}
              className="form-checkbox"
            />
          </div>
          <div className="ml-3 text-sm">
            <label htmlFor="scenarioAnalysis" className="font-medium text-gray-700 dark:text-gray-300">
              Провести сценарный анализ
            </label>
            <p className="text-gray-500 dark:text-gray-400">
              Расчет инвестиции в пессимистичном, базовом и оптимистичном сценариях
            </p>
          </div>
        </div>
        {errors.scenarioAnalysis && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.scenarioAnalysis}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {/* Пессимистичный сценарий */}
        <div>
          <label htmlFor="pessimisticScenario" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Пессимистичный сценарий (% в месяц)
          </label>
          <input
            type="text"
            id="pessimisticScenario"
            name="pessimisticScenario"
            value={formData.pessimisticScenario}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.pessimisticScenario ? 'input-error' : ''}`}
            placeholder="Например: -10"
          />
          {errors.pessimisticScenario && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.pessimisticScenario}
            </p>
          )}
        </div>

        {/* Оптимистичный сценарий */}
        <div>
          <label htmlFor="optimisticScenario" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Оптимистичный сценарий (% в месяц)
          </label>
          <input
            type="text"
            id="optimisticScenario"
            name="optimisticScenario"
            value={formData.optimisticScenario}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.optimisticScenario ? 'input-error' : ''}`}
            placeholder="Например: 30"
          />
          {errors.optimisticScenario && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.optimisticScenario}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-orange-100 dark:bg-orange-900/30 p-3 rounded-lg border border-orange-200 dark:border-orange-800">
        <div className="flex items-start">
          <Activity className="w-5 h-5 text-orange-600 dark:text-orange-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-orange-700 dark:text-orange-300 mb-1">
              О сценарном анализе
            </h4>
            <p className="text-xs text-orange-600 dark:text-orange-400">
              Сценарный анализ позволяет оценить потенциальные результаты инвестиции в разных рыночных условиях. 
              Базовый сценарий использует указанный ожидаемый рост. Пессимистичный и оптимистичный сценарии 
              позволяют оценить возможные отклонения в случае негативного или позитивного развития рынка.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioAnalysisSection;